import React, { memo } from 'react'

import { arrayOf, string } from 'prop-types'

function Lines({ lines }) {
  return lines.map(line => <span key={line} className="variation-info__line">{line}</span>)
}

Lines.propTypes = {
  lines: arrayOf(string).isRequired,
}

export default memo(Lines)
